<template>
  <v-dialog
    v-model="dialog"
    persistent
    scrollable
    max-width="1200px"
  >
    <v-card :loading="loading">
      <v-card-title>
        <span>{{ formTitle }}</span>
        <v-spacer></v-spacer>
        <v-menu
          bottom
          left
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              @click="close()"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
        </v-menu>
      </v-card-title>
      <v-card-text>
        <v-container>
          <div 
            v-if="errors_exist"
            class="row"
          >
            <div class="col">
              <v-alert
                dense
                outlined
                type="error"
              >
                Đã xảy ra lỗi! Vui lòng thử lại. 
                <ul>
                  <div v-for="error in errors">
                    <li>{{ error[0] }}</li>
                  </div>
                </ul>
              </v-alert>
            </div>
          </div>
          <v-row>
            <v-col
              cols="12"
              sm="12"
              md="12"
            >
              <input 
                type="file" 
                @change="onFilePicked" 
                class="d-none" 
                ref="fileInput" 
                accept="image/*"
              />
              <v-img
                v-if="anh_dai_dien_url"
                :src="anh_dai_dien_url"
                class="mx-auto elevation-1"
                @click="onPickFile"
                width="150"
              >
              </v-img>
              <v-img
                v-else
                src="@/assets/NoImage.jpg"
                class="mx-auto elevation-1"
                @click="onPickFile"
                width="150"
              >
              </v-img>
            </v-col>
            <v-col 
              cols="12"
              sm="12"
              md="12"
            >
              <label class="require">Loại</label>
              <v-radio-group
                v-model="typeSelected"
                hide-details
                row
              >
                <v-radio
                  v-for="(type, n) in types"
                  :key="type.value"
                  :label="type.text"
                  :value="type.value"
                ></v-radio>
              </v-radio-group>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="12"
            >
              <v-text-field
                v-model="item.tieu_de"
                label="Tiêu đề"
                class="require"
                autofocus
                hide-details
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="6"
            >
              <v-select
                v-model="areaSelected"
                :items="areas"
                item-text="name"
                item-value="maqh"
                label="Khu vực"
                hide-details
                return-object
              ></v-select>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="6"
            >
              <v-select
                v-model="productTypeSelected"
                :items="product_types"
                item-text="ten_loai"
                item-value="id"
                label="Loại nông sản"
                class="require"
                hide-details
                return-object
              ></v-select>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="12"
            >
              <label class="require">Mô tả</label>
              <quill-editor 
                v-model="item.noi_dung"
                style="min-height: 150px;"
                :options="editorOption"
              >
              </quill-editor>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="12"
            >
              <label>Hình ảnh</label>
              <vue-dropzone 
                ref="myVueDropzone" 
                id="dropzone" 
                :options="dropzoneOptions"
                v-on:vdropzone-success="uploadSuccess"
                v-on:vdropzone-error="uploadError"
                v-on:vdropzone-removed-file="fileRemoved"
                @vdropzone-mounted="loadPictures"
              ></vue-dropzone>
              <div class="red--text text-center">
                Lưu ý: Chỉ chấp nhận tập tin dạng: *.jpg, *.jpeg, *.png và kích thước <= 2MB
              </div>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="12"
            >
              <v-text-field
                type="number"
                v-model="item.giaca"
                label="Giá cả"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="6"
            >
              <v-text-field
                v-model="item.ngay_dang"
                label="Ngày đăng"
                v-mask="'##/##/####'"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="6"
            >
              <v-text-field
                v-model="item.ngay_het_han"
                label="Ngày hết hạn"
                v-mask="'##/##/####'"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="12"
            >
              <v-text-field
                v-model="item.dia_chi"
                label="Địa chỉ"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="12"
            >
              <v-text-field
                v-model="item.so_dien_thoai"
                label="Số điện thoại"
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <small><span class="pink--text">(*)</span> bắt buộc nhập</small>
        <v-spacer/>
        <v-btn
          color="pink darken-1"
          text
          @click="close"
        >
          Hủy bỏ
        </v-btn>
        <v-btn
          color="primary darken-1"
          text
          @click="save(item)"
        >
          Lưu lại
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import vue2Dropzone from 'vue2-dropzone';
  import 'vue2-dropzone/dist/vue2Dropzone.min.css';
  import { mapActions, mapState } from 'vuex';
  export default {
    components: { 
      vueDropzone: vue2Dropzone
    },
    props: {
      showDialog: {
        type: Boolean,
        default: false
      },
      user: {
        type: Number,
        default: 0
      },
      item: {
        type: Object
      }
    },
    data () {
      return {
        loading: false,
        dialog: false,
        anh_dai_dien_url: null,
        errors_exist: false,
        errors: [],
        product_types: [],
        productTypeSelected: null,
        areas: [],
        areaSelected: null,
        types: [
          {text: 'Tôi cần mua', value: '0'}, 
          {text: 'Tôi cần bán', value: '1'}
        ],
        typeSelected: null,
        images: [],
        dropzoneOptions: {
          url: null,
          addRemoveLinks: true,
          dictRemoveFile: "×",
          dictDefaultMessage: "<i class='mdi mdi-24px mdi-arrow-collapse-up'></i> <div>Tải lên hình ảnh</div>",
          acceptedFiles: "image/jpeg,image/png,image/jpg",
          thumbnailWidth: 100,
          thumbnailHeight: 100,
          headers: {
            "Authorization": `Bearer ${JSON.parse(localStorage.getItem('user')).token}`,
            "Cache-Control": null, 
            "X-Requested-With": null
          },
        },
        editorOption: {
          placeholder: 'Nhập văn bản ở đây',
        },
        money: {
          decimal: ',',
          thousands: ',',
          precision: 3,
          masked: false
        },
        invalidIds: []
      }
    },
    computed: {
      ...mapState([
        'config'
      ]),
      formTitle () {
        return this.item.id ? 'Cập nhật' : 'Thêm mới';
      }
    },
    mounted() {
      this.dialog = this.showDialog;
      this.dropzoneOptions.url = `${this.config.beUrl}/api/v1/images`;
      this.getProductTypes();
      this.getAreas();
    },
    watch: {
      showDialog() {
        this.dialog = false;
        this.errors_exist=false;
        if (this.showDialog) {
          this.dialog = true;
          this.anh_dai_dien_url = null;
          if(this.item.anh_dai_dien) 
          {
            this.anh_dai_dien_url = `${this.config.beUrl}/uploads/${this.item.anh_dai_dien}`;
          }
          this.productTypeSelected = this.product_types.find(
            element => element.id == this.item.loai_sp_id
          );
          this.areaSelected = this.areas.find(
            element => element.maqh == this.item.khu_vuc_id
          );
          if(this.item.the_loai_id){
            this.typeSelected = this.item.the_loai_id.toString();
          }
          this.loadPictures();
        }
      }
    },
    methods: {
      ...mapActions([
        'openSnackbar'
      ]),
      getAreas () {
        axios.get("api/v1/get-district-by-province")
          .then(response => {
            this.areas = response.data;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      getProductTypes () {
        axios.get("api/v1/public/product-types")
          .then(response => {
            this.product_types = response.data;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      close(item) {
        this.dialog = false;
        this.$emit('cancelled');
      },
      save(item) {
        const app = this;
        let method = "post";
        let url = `api/v1/tincungcaus`;
        let data = item;
        
        app.loading=true;

        if(app.productTypeSelected){
          data.loai_sp_id = app.productTypeSelected.id;
        }

        if(app.areaSelected){
          data.khu_vuc_id = app.areaSelected.maqh;
        }

        if(app.typeSelected){
          data.the_loai_id = app.typeSelected;
        }

        if(app.user){
          data.user_id=app.user;
        }

        data.images = app.images.filter(e => !app.invalidIds.includes(e.id));
        
        if (data.id) {
          method = "patch"
          url = `api/v1/tincungcaus/${data.id}`
        }

        axios[method](url, data)
          .then((response) => {
            if (response.data && response.data.id) {
              this.$emit('confirmed', response.data);
            }
            this.dialog = !this.dialog;
            app.loading=false;
          }).catch(function (error) {
            app.loading=false;
            app.errors_exist = true;
            if(error.response.status === 422) {
              app.errors = error.response.data || {};
            }
          });
      },
      onPickFile () {
        this.$refs.fileInput.click();
      },
      onFilePicked (event) {
        const app = this;

        if(event.target.files.length == 0){
          return false;
        }

        app.loading=true;

        const file = event.target.files[0];
        app.anh_dai_dien_url = URL.createObjectURL(file);

        const config = {
          headers: { 'content-type': 'multipart/form-data' }
        };

        let formData = new FormData();
        formData.append('file', file);

        axios.post('api/v1/images', formData, config)
          .then(function (response) {
            app.item.anh_dai_dien=response.data.filePath;
            app.openSnackbar({ type: 'success' });
            app.loading=false;
          })
          .catch(function (error) {
            app.loading=false;
            app.anh_dai_dien_url = null;
            app.openSnackbar({ type: 'error' });
          });
      },
      uploadSuccess(file, response) {
        app.openSnackbar({ type: 'success' });
        file.previewElement.querySelector("[data-dz-name]").innerHTML = response.filePath;
        this.images.push(response.fileId);
      },
      uploadError(file, message) {
        this.openSnackbar({ type: 'error' });
      },
      fileRemoved(file, error, xhr) {
        const app = this;
        if(app.dropzoneOptions.removeType == "server") {
          axios.post('api/v1/remove-trade-img', {
            id: app.item.id,
            fileName: file.previewElement.querySelector("[data-dz-name]").innerHTML
          })
            .then(function (response) {
              file.previewElement.remove();
              app.invalidIds.push(response.data);
              app.openSnackbar({ type: 'success' });
            })
            .catch(function (error) {
              app.openSnackbar({ type: 'error' });
            });
        } else {
          file.previewElement.remove();
        }
      },
      loadPictures() {
        if(this.$refs.myVueDropzone && this.item.images){
          this.$refs.myVueDropzone.removeAllFiles();
          this.item.images.forEach(image => {
            if(!this.invalidIds.includes(image.id)) {
              var file = { size: 123, name: image.path, type: "image/png" };
              var url = `${this.config.beUrl}/uploads/${image.path}`;
              this.$refs.myVueDropzone.manuallyAddFile(file, url);
            }
          });
        }
      },
    }
  }
</script>